import {
  ChangeDetectionStrategy,
  Component,
  contentChild,
  forwardRef,
  input,
  InputSignal,
  inject,
  signal,
  Signal,
  TemplateRef,
  WritableSignal,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import {
  ControlValueAccessor,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { IGNORE_BITWARDEN_AUTOFILL } from '../bitwarden-autofill.token';
import { CloseOnOffClick } from '../../../../directives/close-on-off-click';

@Component({
  selector: 'aw-search-bar',
  imports: [CommonModule, FormsModule, CloseOnOffClick, ReactiveFormsModule],
  templateUrl: './search-bar.component.html',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => SearchBarComponent),
      multi: true,
    },
  ],
})
export class SearchBarComponent implements ControlValueAccessor {
  protected readonly ignoreBitwardenAutofill = inject(
    IGNORE_BITWARDEN_AUTOFILL
  );
  activeFilterCount: InputSignal<number> = input<number>(0);
  hasFilter: InputSignal<boolean> = input<boolean>(false);
  placeholder: InputSignal<string> = input<string>('Suchen');
  readonly appearance: InputSignal<'default' | 'compact' | 'comfortable'> =
    input<'default' | 'compact' | 'comfortable'>('default');

  readonly quickFilterTemplate: Signal<TemplateRef<unknown> | undefined> =
    contentChild<TemplateRef<unknown>>('quickFilter');
  protected readonly isFilterOpen: WritableSignal<boolean> = signal(false);

  protected value: string = '';
  protected isDisabled: boolean = false;

  private onChange: (value: string) => void = () => {};
  private onTouched: () => void = () => {};

  writeValue(value: string | null): void {
    this.value = value ?? '';
  }

  registerOnChange(fn: (value: string) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.isDisabled = isDisabled;
  }

  onInput(value: string): void {
    this.value = value;
    this.onChange(value);
  }

  onBlur(): void {
    this.onTouched();
  }

  onClear(): void {
    if (this.isDisabled) {
      return;
    }
    this.onInput('');
    this.onTouched();
  }
}
